<template>

  <v-container fluid class="order-info-header">
    <!-- Test Order indicator -->
    <v-row class="mb-4" v-if="isTestOrder">
      <v-col cols="12" class="d-flex align-center justify-center test-order-banner">
        <span v-if="isCredit">TEST CREDIT</span>
        <span v-else>TEST ORDER</span>
      </v-col>
    </v-row>

    <v-row>
      <!-- Brand Image -->
      <v-col cols="12" xs="12" sm="5" md="3" lg="2" class="d-flex align-center justify-sm-start justify-md-center" v-if="order.brand_image_src">
        <div class="brand-image-wrapper">
          <v-avatar tile size="130">
            <img :src="order.brand_image_src" :alt="brandName" />
          </v-avatar>
        </div>
      </v-col>

      <!-- Order Info -->
      <v-col cols="12" xs="12" sm="7" md="9" :lg="isRescheduledRecord ? 6 : 10">
        <div class="d-flex align-center">
          <div class="order-super-title">Order #</div>
          <div class="ml-2 order-title">{{ order.order_number }}</div>
        </div>
        <div class="mt-4">
          <span class="location-name" v-if="uiType === 'receiver'">{{ shipper.name }}</span>
          <router-link :to="generateShipperPageLink(shipper)" v-else>
            <span class="location-name">{{ shipper.name }}</span>
          </router-link>
          <v-icon color="#727272" class="px-2">mdi-arrow-right-thin</v-icon>
          <router-link :to="generateReceiverPageLink(receiver)">
            <span class="location-name">{{ receiver.name }}</span>
          </router-link>
        </div>
        <div class="mt-6">
          <span class="form-field-label">Status:</span>
          <v-chip label outlined :class="`${order.order_status} ml-3`">
            {{ order.order_status }}
          </v-chip>
        </div>
      </v-col>

      <!-- Link to newly placed order (for RESCHEDULED record view) -->
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" v-if="isRescheduledRecord">
        <div class="d-flex flex-column align-center justify-center link-to-new-order-container pa-4 pb-5">
          <div>
            <v-icon color="#FED602">mdi-alert</v-icon>
          </div>
          <div class="link-to-new-order-text">
            This order is being rescheduled.
          </div>
          <div class="mt-4">
            <router-link :to="generateOrderInfoPageLink()">
              Go to the newly placed order
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>

export default {
  name: 'OrderInfoHeader',

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    isTestOrder () {
      return this.order.is_test
    },
    isCredit () {
      return this.order.is_credit
    },
    brandName () {
      return this.order.thirdparty_brand_name
    },
    shipper () {
      return this.order.shipper || {}
    },
    receiver () {
      return this.order.receiver || {}
    },
    isRescheduledRecord () {
      return this.order.order_status === 'RESCHEDULED'
    }
  },

  methods: {
    generateShipperPageLink (shipper) {
      return {
        name: 'shipper-item',
        params: { shipperId: shipper.id }
      }
    },

    generateReceiverPageLink (receiver) {
      return {
        name: 'receiver-item',
        params: { receiverId: receiver.id }
      }
    },

    // Generate link data for order info page (of latest order record)
    generateOrderInfoPageLink () {
      const latestOrder = (this.order.order_history && this.order.order_history.length > 1)
        ? this.order.order_history[this.order.order_history.length - 1]
        : this.order

      return {
        name: 'order-info-overview',
        params: { orderId: latestOrder.id }
      }
    }
  }
}
</script>

<style scoped>
  .order-info-header .brand-image-wrapper {
    border: 1px solid #525252;
    border-radius: 4px;
    padding: 9px 9px;
  }

  .order-info-header .order-super-title {
    font-size: 1.3rem;
    color: #727272;
    text-transform: uppercase !important;
    letter-spacing: 1.7px;
  }

  .order-info-header .order-title {
    font-size: 1.8rem;
  }

  .order-info-header .test-order-banner {
    text-transform: uppercase !important;
    font-size: 1.2rem;
    color: #ffffff;
    font-weight: 500;
    background-color: #E65000;
    border-radius: 4px;
    height: 46px;
  }

  .order-info-header .link-to-new-order-container {
    border: 1px solid #FED602;
    border-radius: 4px;
  }

  .order-info-header .link-to-new-order-text {
    font-size: 1.06rem;
  }

  .order-info-header a {
    text-decoration: none;
  }
  .order-info-header a:hover {
    text-decoration: underline;
  }
</style>
